import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConstantsService } from './../../../services/constants-service';
import { ArchivalConfirm } from './archival-confirm.model';
import { ObservableRequestService } from './../../../services/observable-request.service';

/**
 * Service to perform archival deletion.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
@Injectable()
export class ArchivalConfirmService {
    constructor(private requestService: ObservableRequestService) { }

    // Service method to delete one entity at a time.
    confirmArchival(entityAchivalData: ArchivalConfirm): Observable<any> {
        return this.requestService.deleteRequest(
            ConstantsService.ENTITY_ARCHIVAL_URL,
            JSON.stringify(entityAchivalData),
            this.requestService.getJSONContentType());
    }

    // Service method to delete multiple entities at a time.
    confirmMultipleArchival(entityAchivalData: Array<ArchivalConfirm>): Observable<any> {
        return this.requestService.deleteRequest(
            ConstantsService.ENTITIES_ARCHIVAL_URL,
            JSON.stringify(entityAchivalData),
            this.requestService.getJSONContentType());
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/archival/archivalconfirm/archival-confirm.service.ts